import * as React from "react";
import { Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { MenuItemAddOn } from "../../models";
import MenuItemAddOnView from "./MenuItemAddOnView";

interface Props {
  onlyRead: boolean;
  menuItemAddOns: MenuItemAddOn[];
  sessionItemAddOns: MenuItemAddOn[];
  setAddOns: React.Dispatch<React.SetStateAction<MenuItemAddOn[]>>;
}

const MenuItemAddOns: React.FC<Props> = ({ menuItemAddOns, sessionItemAddOns, setAddOns, onlyRead }) => {

  const updateAddOn = (addOn: MenuItemAddOn) => {
    setAddOns(prev => {
      const removeAddOn = addOn.options.length === 0;

      if (removeAddOn) {
        return prev.filter(a => a.title !== addOn.title);
      }

      return [
        ...prev.filter(a => a.title !== addOn.title),
        addOn,
      ];
    });
  };

  const getSessionItemAddOn = (menuItemAddOn: MenuItemAddOn): MenuItemAddOn => {
    const sessionAddOn = sessionItemAddOns.find((a) => a.title === menuItemAddOn.title);
    return sessionAddOn ?? {
      ...menuItemAddOn,
      options: [],
    }
  }

  const sortedAddOns = [...menuItemAddOns].sort((a, b) => a.pos - b.pos);

  return <div>
    <div className="row" style={{marginTop: 15}}>
      <div className="col-9">
          <Typography variant="h5" gutterBottom className="menu-item-sub-header"
                      align="left">{LocalizerHelper.localized('supplements')}</Typography>
      </div>
    </div>
    <div className="menu-item-supplements-container">
        {sortedAddOns.map((menuItemAddOn: MenuItemAddOn, index) => {
          return <MenuItemAddOnView
            key={index}
            menuItemAddOn={menuItemAddOn}
            sessionAddOn={getSessionItemAddOn(menuItemAddOn)} 
            updateAddOn={updateAddOn}
            onlyRead={onlyRead}
          />;
        })}
    </div>
  </div>
};

export default MenuItemAddOns;
